export { default as WordListFilters } from '@/views/pages/word/components/WordListFilters.vue';
export { default as WordListItem } from '@/views/pages/word/components/WordListItem.vue';
export { default as WordListSort } from '@/views/pages/word/components/WordListSort.vue';
